import React from "react";
import { Tooltip, IconButton, Box } from "@mui/material";
import { Info } from "@mui/icons-material";

interface HoverToolTipProps {
  description: string;
  showIt?: boolean;
  mt?: number;
}

const HoverToolTip: React.FC<HoverToolTipProps> = ({
  description,
  showIt = true,
  mt = 4.5,
}) => {
  if (!showIt) return null;

  return (
    <Box mt={mt}>
      <Tooltip
        title={description}
        placement="top"
        arrow
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: "#707070",
              fontSize: "12px",
              padding: "8px 12px",
            },
          },
        }}
      >
        <IconButton
          size="small"
          sx={{
            padding: "4px",
          }}
        >
          <Info fontSize="small" sx={{ color: "#6B7280" }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default HoverToolTip;
